/**
 * utils/configItemReadiness.ts — FRONTEND MIRROR of supabase/functions/server/configItemReadinessCore.ts.
 *
 * Generated: do not edit by hand; run scripts/sync-discovery-grid-mirror.sh.
 */


import { buildDiscoveryGrid, type GridCell } from './discoveryGrid.ts';

/** How many question names a line lists before "and N more". */
const NAMES_SHOWN = 3;

function names(cells: GridCell[]): string {
  const shown = cells.slice(0, NAMES_SHOWN).map((c) => `"${c.text}"`).join(', ');
  return cells.length > NAMES_SHOWN ? `${shown} and ${cells.length - NAMES_SHOWN} more` : shown;
}

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/**
 * The reasons an item cannot be locked for build yet, one line each; empty when it can. An item
 * already locked (ready for build or later) has nothing left to check.
 */
export function readyForBuildErrors(item: any): string[] {
  if (!item?.id) return [];
  const grid = buildDiscoveryGrid({ items: [item], guided: [], links: { companyId: String(item.companyId ?? ''), sowId: null } });
  const block = grid.regions.flatMap((r) => r.blocks).find((b) => b.configItemId === item.id);
  const cells = (block?.cells ?? []).filter((c) => c.kind === 'question' && !c.descoped);
  const at = (level: number) => cells.filter((c) => c.level === level);
  const errors: string[] = [];
  const unanswered = at(0);
  const suggested = at(1);
  const followUps = at(2);
  if (unanswered.length) errors.push(`${plural(unanswered.length, 'question is', 'questions are')} not answered: ${names(unanswered)}`);
  if (suggested.length) errors.push(`${plural(suggested.length, 'AI suggestion is', 'AI suggestions are')} not confirmed: ${names(suggested)}`);
  if (followUps.length) errors.push(`${plural(followUps.length, 'follow-up is', 'follow-ups are')} still open: ${names(followUps)}`);
  return errors;
}
